import React, { useMemo } from 'react';
import { Button, FontIcon } from 'react-md';

import { withT } from 'lib/i18n';

import FocusFeedDefinitionLayoutMedia from './Sections/Media';
import FocusFeedDefinitionLayoutBrand from './Sections/Brand';
import FocusFeedDefinitionLayoutContent from './Sections/Content';
import FocusFeedDefinitionLayoutProductType from './Sections/ProductType';
import FocusFeedDefinitionInformation from './Sections/Information';

import { ComponentProps } from './types';

import './FocusFeedDefinitionLayout.scss';

const FocusFeedDefinitionLayout = (props: ComponentProps) => {
	const { onFetchSearch, t, brand_sync } = props;
	const {
		productNameQueries, contentQueries, brands, productTypes, medias,
		showAutocompleteUrlPlaceholder = false
	} = props;

	const searchButton = useMemo(() => (
		<Button id="focusFeedDefinitionSearchBtn" className="definition-header-search-button" flat
			disabled={brand_sync}
			onClick={() => onFetchSearch()}
		>
			<FontIcon>search</FontIcon>
			{t('form.search.value')}
		</Button>
	), [onFetchSearch, t, brand_sync]);

	return (
		<>
			<div>{searchButton}</div>
			{<FocusFeedDefinitionInformation {...props}></FocusFeedDefinitionInformation>}
			{brands && <FocusFeedDefinitionLayoutBrand {...brands}></FocusFeedDefinitionLayoutBrand>}
			{productTypes && <FocusFeedDefinitionLayoutProductType {...productTypes}></FocusFeedDefinitionLayoutProductType>}
			{/* TODO: ContentSection should be renamed to QuerySearchSection or something like that */}
			{productNameQueries && <FocusFeedDefinitionLayoutContent {...productNameQueries}></FocusFeedDefinitionLayoutContent>}
			{contentQueries && <FocusFeedDefinitionLayoutContent {...contentQueries}></FocusFeedDefinitionLayoutContent>}
			{medias && <FocusFeedDefinitionLayoutMedia
				{...medias}
				showAutocompleteUrlPlaceholder={showAutocompleteUrlPlaceholder}
			></FocusFeedDefinitionLayoutMedia>}
		</>
	);
};

export default withT(React.memo(FocusFeedDefinitionLayout));
